export const trimPrefix = (geoType) => {
  const possiblePrefix = geoType?.slice(0, 2);

  if (possiblePrefix === 'By') {
    return geoType.slice(2).toLowerCase();
  }

  return geoType?.toLowerCase();
};

export const itemTypes = {
  hotel: 'hotel',
  resort: 'resort',
  area: 'area',
  country: 'country',
  region: 'region',
  destination: 'destination',
  cruise: 'cruise',
  cruiseship: 'cruiseship',
  cruiseshipcomp: 'cruiseshipcomp',
  packagePlus: 'packageplus',
  excursion: 'excursion',
};

export const subTypes = {
  beach: 'beach',
  carRental: 'carRental',
  golf: 'golf',
  busTaxi: 'busTaxi',
  shopping: 'shopping',
  attractions: 'attractions',
  activities: 'activities',
  foodBeverage: 'foodBeverage',
  service: 'service',
  health: 'health',
  safeTravel: 'safeTravel',
  restaurants: 'restaurants',
  activeTraining: 'activeTraining',
  excursions: 'excursions',
};

export const isHotel = (itemType) => {
  return trimPrefix(itemType) === itemTypes.hotel;
};

export const isArea = (itemType) => {
  return trimPrefix(itemType) === itemTypes.area;
};

export const isResort = (itemType) => {
  return trimPrefix(itemType) === itemTypes.resort;
};

export const isCountry = (itemType) => {
  return trimPrefix(itemType) === itemTypes.country;
};

export const isRegion = (itemType) => {
  return trimPrefix(itemType) === itemTypes.region;
};

export const isCruise = (itemType) => {
  return trimPrefix(itemType) === itemTypes.cruise;
};

export const isCruiseship = (itemType) => {
  return trimPrefix(itemType) === itemTypes.cruiseship;
};

export const isCruiseshipcomp = (itemType) => {
  return trimPrefix(itemType) === itemTypes.cruiseshipcomp;
};
